export var Market;
(function (Market) {
    Market[Market["de"] = 1000] = "de";
    Market[Market["at"] = 1001] = "at";
    Market[Market["ch"] = 1002] = "ch";
    Market[Market["fr"] = 1003] = "fr";
})(Market || (Market = {}));
export var marketContextMap = new Map([
    [Market.de, {
            market: 1000,
            language: 'de',
            country: 'DE',
            currency: 'EUR'
        }],
    [Market.at, {
            market: 1001,
            language: 'de',
            country: 'AT',
            currency: 'EUR'
        }],
    [Market.ch, {
            market: 1002,
            language: 'de',
            country: 'CH',
            currency: 'CHF'
        }],
    [Market.fr, {
            market: 1003,
            language: 'fr',
            country: 'FR',
            currency: 'EUR'
        }]
]);
export default Market;
